import type { Translation } from './en';

const es: Translation = {
  app: {
    name: 'Dishly',
  },
  common: {
    cancel: 'Cancelar',
    close: 'Cerrar',
    save: 'Guardar',
    loading: 'Cargando…',
    retry: 'Reintentar',
    create: 'Crear',
    undo: 'Deshacer',
    more: 'Más opciones',
  },
  nav: {
    home: 'Inicio de Dishly',
    add: 'Añadir',
    addRecipe: 'Añadir una receta',
    shoppingList: 'Lista de la compra',
    lists: 'Mis listas',
    myRecipes: 'Mis recetas',
    account: 'Cuenta',
    logIn: 'Iniciar sesión / Registrarse',
    logOut: 'Cerrar sesión',
    themeDark: 'Cambiar al tema oscuro',
    themeLight: 'Cambiar al tema claro',
    language: 'Idioma',
    userMenu: 'Menú de la cuenta',
    offline: 'Sin conexión',
    offlineHint: 'Estás sin conexión. Las recetas descargadas y tus listas siguen funcionando.',
  },
  home: {
    title: 'Recetas',
    count_one: '{{count}} receta',
    count_other: '{{count}} recetas',
    tags: 'Etiquetas',
    showAll: 'Ver todas',
    sortLabel: 'Ordenar por',
    sort: {
      newest: 'Más recientes',
      rating: 'Mejor valoradas',
      quickest: 'Más rápidas',
      name: 'A–Z',
    },
    viewGrid: 'Vista de cuadrícula',
    viewList: 'Vista de lista',
    empty: 'Todavía no hay recetas.',
    emptyHint: '¡Sé la primera persona en compartir una!',
    noMatches: 'Ninguna receta tiene todas estas etiquetas.',
    noMatchesHint: 'Prueba a quitar una etiqueta.',
    offlineEmpty: 'Estás sin conexión y todavía no se ha descargado ninguna receta. Conéctate una vez y estarán disponibles sin conexión.',
    end: '¡Eso es todo!',
    backToTop: 'Volver arriba',
  },
  tags: {
    breakfast: 'Desayuno',
    brunch: 'Brunch',
    lunch: 'Almuerzo',
    dinner: 'Cena',
    vegetarian: 'Vegetariana',
    vegan: 'Vegana',
    'gluten-free': 'Sin gluten',
  },
  rating: {
    none: 'Sin valoraciones todavía',
    label_one: 'Valorada con {{rating}} de 5 por {{count}} persona',
    label_other: 'Valorada con {{rating}} de 5 por {{count}} personas',
    rateStars_one: 'Valorar con {{count}} estrella',
    rateStars_other: 'Valorar con {{count}} estrellas',
  },
  cart: {
    add: 'Añadir a la lista de la compra',
    remove: 'Quitar de la lista de la compra',
    added: 'Añadida a tu lista de la compra',
    removed: 'Quitada de tu lista de la compra',
    view: 'Ver',
  },
  badge: {
    draft: 'Borrador',
    private: 'Privada',
  },
  recipe: {
    by: 'por {{name}}',
    servings_one: '{{count}} ración',
    servings_other: '{{count}} raciones',
    fewerServings: 'Menos raciones',
    moreServings: 'Más raciones',
    units: 'Unidades',
    metric: 'Métrico',
    imperial: 'Imperial',
    ingredients: 'Ingredientes',
    noIngredients: 'No hay ingredientes.',
    method: 'Preparación',
    startCooking: 'Empezar a cocinar',
    continueCooking: 'Continuar desde el paso {{step}}',
    stepOf: 'Paso {{current}} de {{total}}',
    next: 'Siguiente paso',
    finish: 'Terminar',
    returnToCurrent: 'Volver al paso actual',
    progress: 'Progreso de la receta',
    goToStep: 'Ir al paso {{step}}',
    stepDone: 'Paso completado',
    startOver: 'Empezar de nuevo',
    finishedTitle: '¡Que aproveche!',
    finishedBody: '¿Qué tal te ha salido?',
    rateThis: 'Valora esta receta',
    yourRating: 'Tu valoración',
    ownRecipe: 'Es tu receta, así que no puedes valorarla.',
    reviews: 'Reseñas',
    noReviews: 'Todavía no hay comentarios.',
    loadMore: 'Ver más',
    favourite: 'Añadir a favoritas',
    unfavourite: 'Quitar de favoritas',
    favourited: 'Añadida a favoritas',
    unfavourited: 'Quitada de favoritas',
    saveToList: 'Guardar en una lista',
    newListPlaceholder: 'Nombre de la nueva lista',
    edit: 'Editar',
    delete: 'Eliminar',
    deleteTitle: '¿Eliminar esta receta?',
    deleteBody: 'Se eliminará para todo el mundo. No se puede deshacer.',
    deleted: 'Receta eliminada',
    draftNotice: 'Esto es un borrador. Solo tú puedes verlo.',
    privateNotice: 'Esta receta es privada. Solo tú puedes verla.',
    notFound: 'Receta no encontrada',
    notFoundBody: 'Puede que se haya eliminado o que ahora sea privada.',
    notDownloaded: 'Esta receta todavía no se ha descargado. Conéctate a internet para abrirla; después funcionará sin conexión.',
    addThese: 'Añade lo siguiente:',
    notes: 'Notas',
    photo: 'Foto {{n}} de {{total}}',
    startTimer: 'Iniciar temporizador de {{duration}}',
    timerRunning: 'Temporizador en marcha',
  },
  steps: {
    add_ingredients: 'Añadir ingredientes',
    cook: 'Cocinar',
    prep: 'Preparar',
  },
  heat: {
    low: 'Fuego bajo',
    medium_low: 'Fuego medio-bajo',
    medium: 'Fuego medio',
    medium_high: 'Fuego medio-alto',
    high: 'Fuego alto',
  },
  method: {
    pan: 'Sartén',
    pot: 'Cazo',
    oven: 'Horno',
    grill: 'Grill',
    bbq: 'Barbacoa',
    steamer: 'Vaporera',
    deep_fryer: 'Freidora',
    air_fryer: 'Freidora de aire',
    microwave: 'Microondas',
    slow_cooker: 'Olla de cocción lenta',
    pressure_cooker: 'Olla a presión',
    other: 'Otro',
  },
  review: {
    title: '¡Gracias por tu valoración!',
    saved: 'Valoración guardada',
    commentLabel: 'Añade un comentario (opcional)',
    commentPlaceholder: '¿Qué te ha parecido? ¿Algún cambio?',
    post: 'Publicar comentario',
    skip: 'No, gracias',
    editComment: 'Editar comentario',
    remove: 'Quitar mi valoración',
    removed: 'Valoración quitada',
  },
  lists: {
    title: 'Mis listas',
    shopping: 'Lista de la compra',
    favourites: 'Favoritas',
    new: 'Nueva lista',
    namePlaceholder: 'p. ej., Cenas entre semana',
    rename: 'Renombrar lista',
    delete: 'Eliminar lista',
    deleteTitle: '¿Eliminar «{{name}}»?',
    deleteBody: 'Las recetas no se eliminan.',
    empty: 'Esta lista está vacía.',
    emptyShopping: 'Toca la cesta de cualquier receta para añadir aquí sus ingredientes.',
    emptyOther: 'Guarda recetas en esta lista desde la página de cada receta.',
    browse: 'Ver recetas',
    recipes_one: '{{count}} receta',
    recipes_other: '{{count}} recetas',
    consolidate: 'Combinar ingredientes',
    consolidateHint: 'Una sola lista para todo. Las recetas contraídas no se incluyen.',
    collapsedExcluded_one: '{{count}} receta contraída no se incluye.',
    collapsedExcluded_other: '{{count}} recetas contraídas no se incluyen.',
    nothingToCombine: 'Despliega una receta para incluir sus ingredientes.',
    expand: 'Mostrar ingredientes',
    collapse: 'Ocultar ingredientes (guardar para más tarde)',
    remove: 'Quitar de la lista',
    removed: 'Se ha quitado «{{name}}»',
    export: 'Exportar',
    copy: 'Copiar al portapapeles',
    copied: '¡Copiada! Pégala en Notas o en cualquier app.',
    copyFailed: 'No se ha podido copiar la lista.',
    share: 'Compartir…',
    unavailable: 'Esta receta ya no está disponible.',
    uncheckAll: 'Desmarcar todo',
    progress: '{{done}} de {{total}} marcados',
  },
  myRecipes: {
    title: 'Mis recetas',
    drafts: 'Borradores',
    private: 'Privadas',
    public: 'Públicas',
    emptyDrafts: 'No hay borradores. Las recetas que empieces se guardan aquí automáticamente.',
    emptyPrivate: 'No hay recetas privadas.',
    emptyPublic: 'Todavía no has publicado ninguna receta.',
    untitled: 'Receta sin título',
    edited: 'Editada el {{date}}',
  },
  newRecipe: {
    title: 'Añadir una receta',
    subtitle: '¿Cómo quieres empezar?',
    photoTitle: 'Fotografía una receta en papel',
    photoBody: 'Haz una foto de una ficha o de la página de un libro de cocina y la IA la convertirá en una receta de Dishly.',
    describeTitle: 'Descríbelo o dilo',
    describeBody: 'Escribe o di lo que tienes, como «pollo, patatas, coliflor y especias normales», y la IA creará una receta.',
    manualTitle: 'Escríbela tú',
    manualBody: 'Añade tu receta paso a paso. Tu trabajo se guarda sobre la marcha.',
    comingSoon: 'Próximamente',
    comingSoonBody: 'La creación de recetas con IA todavía no está disponible. Mientras tanto, puedes escribir la receta tú.',
    choosePhoto: 'Haz o elige una foto',
    describePlaceholder: 'Tengo pollo, patatas, coliflor y especias normales…',
    generate: 'Crear receta',
    writeManually: 'Escribirla yo',
    drafts: 'Continuar un borrador',
    addPage: 'Añadir otra página',
    photoHint: 'Hasta {{count}} fotos, por ejemplo las dos páginas de un libro de cocina.',
    noteLabel: '¿Algo que añadir? (opcional)',
    notePlaceholder: 'p. ej. «Para 6 personas» o «Al horno, no a la parrilla»',
    voiceHint: 'O toca el micrófono y dilo.',
    working: 'Escribiendo tu receta…',
    workingPhotos: 'Leyendo tus fotos…',
    linkTitle: 'Pega un enlace',
    linkBody: '¿Has encontrado una receta en una web? Pega el enlace y la IA la trae a Dishly, con foto y todo.',
    linkLabel: 'Enlace a la receta',
    linkHint: 'Funciona con la mayoría de webs de recetas. La web aparece citada en la receta y puedes revisarlo todo antes de publicarla.',
    workingLink: 'Leyendo la página…',
    workingHint: 'Puede tardar hasta un minuto. No cierres esta página.',
  },
  save: {
    button: 'Guardar en Dishly',
    title: 'Guardar en Dishly',
    dragHint: 'Arrastra este botón a tu barra de marcadores y haz clic en él en cualquier página de recetas.',
    tip: 'Guarda recetas directamente desde tu navegador: arrastra este botón a tu barra de marcadores y haz clic en él en una página de recetas.',
    setUp: 'Arrastra este botón a tu barra de marcadores. Después, en cualquier página de recetas, haz clic en él para traer la receta a Dishly.',
    howTo: 'Esta página se abre al hacer clic en «Guardar en Dishly» en tu barra de marcadores, en una página de recetas. En el móvil, pega el enlace de la receta o haz capturas de pantalla.',
    popupBlocked: 'Permite las ventanas emergentes en esta web para guardar la receta en Dishly.',
    waiting: 'Obteniendo la página de la receta…',
    nothing: 'No ha llegado nada de la página de la receta',
    nothingHint: 'Vuelve a la página de la receta y haz clic de nuevo en «Guardar en Dishly».',
    confirm: '¿Traer esta receta de {{site}} a Dishly? La IA la escribe como borrador para que la revises.',
    import: 'Importar receta',
    blocked: '{{site}} no deja que las apps lean sus recetas.',
    blockedDesktop: 'Aun así puedes guardarla desde tu navegador: arrastra el botón de abajo a tu barra de marcadores, abre la receta y haz clic en el marcador. O haz capturas de pantalla y usa «Fotografía una receta en papel».',
    blockedMobile: 'Haz capturas de pantalla de la receta (hasta 4) y usa «Fotografía una receta en papel».',
  },
  voice: {
    start: 'Grabar tu voz',
    stop: 'Detener la grabación',
    say: 'Dilo',
    transcribing: 'Transcribiendo…',
    denied: 'El acceso al micrófono está bloqueado. Permítelo en los ajustes del navegador para usar tu voz.',
    unavailable: 'No se ha podido activar el micrófono.',
    nothingHeard: 'No te hemos entendido. Inténtalo de nuevo.',
  },
  adapt: {
    open: 'Preguntar o cambiar',
    title: 'Pregunta o cambia esta receta',
    intro: 'Haz una pregunta, como «Mi horno no tiene gratinador, ¿qué puedo usar?», o di qué cambiar, como «No tengo salsa de pescado». Los cambios son solo para ti.',
    placeholder: 'Haz una pregunta o di qué cambiar…',
    submit: 'Enviar',
    working: 'Pensando…',
    you: 'Tú',
    changed: 'Receta actualizada',
    noChange: 'No se ha cambiado nada.',
    noticeTitle: 'Adaptada para ti',
    noticeBody: 'Solo tú ves esta versión. La receta original no cambia.',
    changedStep: 'Cambiado',
    saveCopy: 'Guardar como copia mía',
    copySaved: 'Guardada en tus recetas',
    adaptedFrom: 'Adaptada de [{{name}}]({{path}}), de {{author}}.',
    apply: 'Aplicar a la receta',
    applyTitle: '¿Actualizar tu receta con estos cambios?',
    applyBody: 'Todos los que pueden ver esta receta verán la versión cambiada.',
    applied: 'Receta actualizada',
    applyInvalid: 'A la receta cambiada le falta algo necesario. Guárdala como copia o edita la receta.',
    discard: 'Volver al original',
  },
  editor: {
    newTitle: 'Nueva receta',
    editTitle: 'Editar receta',
    name: 'Nombre de la receta',
    namePlaceholder: 'p. ej., El crumble de manzana de la abuela',
    photos: 'Fotos',
    photosHint: 'La primera foto es la portada.',
    addPhotos: 'Añadir fotos',
    uploading: 'Subiendo…',
    cover: 'Portada',
    makeCover: 'Usar como portada',
    removePhoto: 'Quitar foto',
    uploadFailed: 'Error al subir: {{message}}',
    tooManyPhotos: 'Puedes añadir hasta {{count}} fotos.',
    description: 'Sobre esta receta',
    descriptionPlaceholder: 'La historia que hay detrás, consejos, con qué servirla…',
    write: 'Escribir',
    preview: 'Vista previa',
    markdownHint: 'Admite Markdown: **negrita**, *cursiva*, listas y enlaces.',
    nothingToPreview: 'Todavía no hay nada que previsualizar.',
    details: 'Detalles',
    totalTime: 'Tiempo total (minutos)',
    stepTotal: 'Los pasos con tiempo suman {{duration}}.',
    useStepTotal: 'Usar este valor',
    servings: 'Raciones',
    tags: 'Etiquetas',
    steps: 'Pasos',
    stepsHint: 'Quien cocine verá un paso cada vez.',
    noSteps: 'Todavía no hay pasos. Añade el primero aquí abajo.',
    addStep: 'Añadir un paso',
    stepTypeHelp: {
      add_ingredients: 'Uno o más ingredientes con sus cantidades',
      cook: 'Aplicar calor: saltear, hornear, cocer a fuego lento…',
      prep: 'Picar, mezclar, reposar, forrar una bandeja…',
    },
    stepNumber: 'Paso {{n}}',
    stepType: 'Tipo de paso',
    instruction: 'Instrucción',
    instructionOptional: 'Instrucción (opcional)',
    instructionPlaceholder: {
      add_ingredients: 'p. ej., Bate todo en un bol grande',
      cook: 'p. ej., Saltea hasta que esté blando y dorado',
      prep: 'p. ej., Corta los tomates en dados',
    },
    ingredients: 'Ingredientes',
    addIngredient: 'Añadir ingrediente',
    ingredient: 'Ingrediente',
    ingredientPlaceholder: 'p. ej., aceite de oliva',
    quantity: 'Cantidad',
    quantityPlaceholder: 'p. ej., 1½',
    unit: 'Unidad',
    unitNone: 'entero / sin unidad',
    note: 'Nota',
    notePlaceholder: 'p. ej., picado fino',
    removeIngredient: 'Quitar ingrediente',
    equipment: 'Utensilio',
    heat: 'Fuego',
    notSpecified: 'Sin especificar',
    temperature: 'Temperatura (°{{unit}})',
    duration: 'Tiempo (minutos)',
    durationHint: 'Añade un botón de temporizador a este paso.',
    notes: 'Notas',
    addNotes: 'Añadir notas',
    notesPlaceholder: 'Consejos o detalles para este paso',
    stepPhotos: 'Fotos del paso',
    addStepPhotos: 'Añadir fotos',
    moveUp: 'Subir el paso',
    moveDown: 'Bajar el paso',
    deleteStep: 'Eliminar paso',
    dragStep: 'Arrastra para reordenar',
    overview: 'Resumen de ingredientes',
    overviewHint: 'Se genera automáticamente a partir de tus pasos «Añadir ingredientes».',
    overviewEmpty: 'Aquí aparecerán los ingredientes que añadas en los pasos.',
    save: 'Guardar receta',
    saveTitle: 'Guarda tu receta',
    saveBody: '¿Quién debería poder verla?',
    public: 'Pública',
    publicHint: 'Compártela con toda la comunidad de Dishly.',
    private: 'Privada',
    privateHint: 'Solo tú puedes verla. Puedes publicarla más tarde.',
    recommended: 'Recomendado',
    published: '¡Receta publicada!',
    savedPrivate: 'Guardada en tus recetas privadas.',
    status: {
      saving: 'Guardando…',
      saved: 'Borrador guardado',
      local: 'Guardado en este dispositivo',
      offline: 'Sin conexión: guardado en este dispositivo',
      error: 'No se ha podido guardar',
    },
    fixErrors: 'Corrige los campos marcados.',
    errors: {
      required: 'Obligatorio',
      number: 'Escribe un número',
      name: 'Ponle un nombre a tu receta',
      steps: 'Añade al menos un paso',
      instruction: 'Describe este paso',
      ingredients: 'Añade al menos un ingrediente',
      ingredientName: 'Escribe el ingrediente',
    },
    deleteDraft: 'Eliminar borrador',
    deleteDraftTitle: '¿Eliminar este borrador?',
    deleteDraftBody: 'No se puede deshacer.',
    restoreTitle: 'Hay cambios sin guardar',
    restoreBody: 'Tienes cambios en esta receta del {{date}} que no se guardaron.',
    aiTitle: 'Escrita por IA',
    aiBody: 'Revisa los ingredientes, las cantidades y los pasos, y después guárdala. No se publica nada hasta que lo hagas.',
    restore: 'Recuperarlos',
    discard: 'Descartar',
    offlineUnavailable: 'Esta receta no está descargada. Conéctate a internet para editarla.',
    notYours: 'Solo puedes editar tus propias recetas.',
  },
  auth: {
    title: 'Te damos la bienvenida a Dishly',
    loginTab: 'Iniciar sesión',
    signupTab: 'Registrarse',
    email: 'Correo electrónico',
    password: 'Contraseña',
    displayName: 'Nombre visible',
    displayNameHint: 'Aparece en tus recetas y reseñas.',
    passwordHint: 'Al menos 8 caracteres.',
    showPassword: 'Mostrar contraseña',
    hidePassword: 'Ocultar contraseña',
    forgot: '¿Has olvidado tu contraseña?',
    logIn: 'Iniciar sesión',
    createAccount: 'Crear cuenta',
    loginToContinue: 'Inicia sesión o crea una cuenta para continuar.',
    welcomeBack: '¡Hola de nuevo, {{name}}!',
    checkEmailTitle: 'Revisa tu correo',
    checkEmailBody: 'Hemos enviado un enlace a {{email}}. Púlsalo para confirmar tu dirección y después inicia sesión.',
    resend: 'Reenviar el correo',
    resent: '¡Enviado! Revisa tu bandeja de entrada (y la de spam).',
    backToLogin: 'Volver a iniciar sesión',
    notVerified: 'Primero confirma tu correo. Busca el enlace en tu bandeja de entrada.',
    recaptcha: 'Protegido por reCAPTCHA: se aplican la <privacy>Política de privacidad</privacy> y las <terms>Condiciones del servicio</terms> de Google.',
    verifyTitle: 'Confirma tu correo',
    verifying: 'Confirmando tu correo…',
    verified: '¡Correo confirmado!',
    verifiedBody: 'Ya puedes iniciar sesión en Dishly.',
    verifyFailed: 'No hemos podido confirmar tu correo.',
    verifyExpired: 'Este enlace ha caducado. Escribe tu correo para recibir uno nuevo.',
    forgotTitle: 'Restablece tu contraseña',
    forgotBody: 'Escribe tu correo y te enviaremos un enlace para elegir una contraseña nueva.',
    sendLink: 'Enviar enlace',
    linkSent: 'Si existe una cuenta para {{email}}, el enlace está en camino.',
    resetTitle: 'Elige una contraseña nueva',
    newPassword: 'Contraseña nueva',
    confirmPassword: 'Confirma la contraseña nueva',
    passwordsDontMatch: 'Las contraseñas no coinciden.',
    savePassword: 'Guardar contraseña',
    passwordUpdated: 'Contraseña actualizada. Ya puedes iniciar sesión.',
    resetInvalid: 'Este enlace no es válido o ha caducado.',
    requestNew: 'Pedir un enlace nuevo',
  },
  account: {
    title: 'Cuenta',
    profile: 'Perfil',
    displayName: 'Nombre visible',
    email: 'Correo electrónico',
    memberSince: 'Miembro desde el {{date}}',
    saved: 'Guardado',
    preferences: 'Preferencias',
    units: 'Unidades preferidas',
    metric: 'Métricas (g, ml, °C)',
    imperial: 'Imperiales (oz, tazas, °F)',
    language: 'Idioma predeterminado',
    theme: 'Tema',
    themeSystem: 'Sistema',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    security: 'Contraseña',
    resetPassword: 'Restablecer contraseña',
    resetHint: 'Te enviaremos un enlace para elegir una contraseña nueva.',
    resetSent: 'Busca el enlace para restablecerla en tu correo.',
    logOut: 'Cerrar sesión',
  },
  timers: {
    title: 'Temporizadores',
    done: '¡Listo!',
    pause: 'Pausar temporizador',
    resume: 'Reanudar temporizador',
    cancel: 'Cancelar temporizador',
    dismiss: 'Descartar',
    started: 'Temporizador iniciado: {{duration}}',
    notificationTitle: 'Temporizador terminado',
    goToStep: 'Ir al paso',
  },
  pwa: {
    updateAvailable: 'Hay una nueva versión de Dishly.',
    update: 'Actualizar',
  },
  notFound: {
    title: 'Página no encontrada',
    body: 'No hemos encontrado lo que buscabas.',
    home: 'Ir a las recetas',
  },
  errors: {
    generic: 'Algo ha fallado. Inténtalo de nuevo.',
    network: 'No tienes conexión o no se puede contactar con el servidor.',
    codes: {
      invalid_credentials: 'El correo o la contraseña no son correctos.',
      email_not_verified: 'Primero confirma tu dirección de correo.',
      rate_limited: 'Demasiados intentos. Espera unos minutos y vuelve a intentarlo.',
      captcha_required: 'Completa la verificación captcha.',
      captcha_failed: 'La verificación captcha ha fallado. Inténtalo de nuevo.',
      captcha_unavailable: 'No hemos podido comprobar el captcha. Inténtalo de nuevo.',
      token_expired: 'Este enlace ha caducado.',
      token_invalid: 'Este enlace no es válido o ya se ha usado.',
      email_failed: 'No hemos podido enviar el correo. Inténtalo de nuevo en un momento.',
      too_large: 'Es demasiado grande.',
      unsupported_image: 'Sube una imagen JPEG, PNG, WebP, GIF o AVIF.',
      invalid_image: 'No se ha podido procesar la imagen.',
      too_many_lists: 'Has alcanzado el número máximo de listas.',
      own_recipe: 'No puedes valorar tu propia receta.',
      not_found: 'No encontrado.',
      forbidden: 'No tienes permiso para hacer esto.',
      unauthorized: 'Inicia sesión para continuar.',
      validation_error: 'Hay campos no válidos.',
      invalid_recipe: 'Corrige los campos marcados.',
      builtin_list: 'Las listas predeterminadas no se pueden cambiar.',
      server_error: 'Algo ha fallado en nuestro servidor.',
      ai_disabled: 'Las funciones de IA no están disponibles ahora mismo.',
      ai_unavailable: 'El servicio de IA no responde. Inténtalo de nuevo en un momento.',
      ai_failed: 'La IA no ha podido terminar. Inténtalo de nuevo.',
      ai_refused: 'La IA no puede ayudar con esa petición.',
      unsupported_audio: 'Ese formato de grabación no es compatible.',
      invalid_url: 'Eso no parece una dirección web.',
      page_unreachable: 'No hemos podido abrir esa página. Revisa el enlace e inténtalo de nuevo.',
      page_blocked: 'Esa web no deja que las apps lean sus recetas. Haz una captura de pantalla y usa «Fotografía una receta en papel».',
      not_a_page: 'Ese enlace no es una página web.',
    },
  },
  time: {
    seconds_one: '{{count}} s',
    seconds_other: '{{count}} s',
    minutes_one: '{{count}} min',
    minutes_other: '{{count}} min',
    hours_one: '{{count}} h',
    hours_other: '{{count}} h',
    hoursMinutes: '{{hours}} h {{minutes}} min',
  },
  units: {
    g: 'g',
    kg: 'kg',
    oz: 'oz',
    lb: 'lb',
    ml: 'ml',
    l: 'l',
    tsp: 'cdta.',
    tbsp: 'cda.',
    cup_one: 'taza',
    cup_other: 'tazas',
    fl_oz: 'fl oz',
    pint_one: 'pinta',
    pint_other: 'pintas',
    pinch_one: 'pizca',
    pinch_other: 'pizcas',
    clove_one: 'diente',
    clove_other: 'dientes',
    slice_one: 'rebanada',
    slice_other: 'rebanadas',
    can_one: 'lata',
    can_other: 'latas',
    bunch_one: 'manojo',
    bunch_other: 'manojos',
    sprig_one: 'ramita',
    sprig_other: 'ramitas',
    handful_one: 'puñado',
    handful_other: 'puñados',
    package_one: 'paquete',
    package_other: 'paquetes',
  },
  unitNames: {
    g: 'gramos (g)',
    kg: 'kilogramos (kg)',
    oz: 'onzas (oz)',
    lb: 'libras (lb)',
    ml: 'mililitros (ml)',
    l: 'litros (l)',
    tsp: 'cucharaditas (cdta.)',
    tbsp: 'cucharadas (cda.)',
    cup: 'tazas',
    fl_oz: 'onzas líquidas (fl oz)',
    pint: 'pintas',
    pinch: 'pizca',
    clove: 'dientes',
    slice: 'rebanadas',
    can: 'latas',
    bunch: 'manojos',
    sprig: 'ramitas',
    handful: 'puñados',
    package: 'paquetes',
  },
  unitGroups: {
    mass: 'Peso',
    volume: 'Volumen',
    other: 'Otras',
  },
};

export default es;
